/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Checkbox } from "@/components/ui/checkbox";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
// import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
// import { getObject } from "@/lib/object-mutation";

export const IsSimilarityMatch = ({
  data,
  parentKey,
  // keyValue,
  // review_required,
  review_required_row_no,
  // temp_reviewed,
  // data_review_required,
}: {
  parentKey: string;
  data: any;
  keyValue: any;
  review_required: any;
  review_required_row_no: any;
  temp_reviewed: any;
  data_review_required: any;
}) => {
  const [
    _state,
    _setState,
    _searchAddress,
    _updateAddress,
    _searchSupplier,
    _updateSupplierMapping,
    _searchItemMaster,
    _updateItemMaster,
    _mutationMasterData,
    onUpdateIsSimilarityMatch,
  ] = useDocument();
  const isReadOnly = useDocumentReadOnly();

  // const requiredItems = data.filter(
  //   (item: any) =>
  //     review_required_row_no.includes(item?.row_number) && !item.is_deleted,
  // );

  const isAllChecked =
    data?.length > 0 && data?.every((item: any) => item?.text == "true");

  const handleCheckedAll = () => {
    data.forEach((item: any, index: number) => {
      // const isReviewRequired = review_required_row_no.includes(
      //   item?.row_number,
      // );
      if (!item.is_deleted) {
        const for_review = isAllChecked ? "false" : "true";
        const for_review_required = isAllChecked ? "true" : "false";
        // console.log({ isAllChecked });
        // console.log(parentKey + ".reviewed." + index, for_review);
        // console.log(
        //   parentKey + ".review_required." + index,
        //   for_review_required,
        // );
        onUpdateIsSimilarityMatch(parentKey + ".reviewed." + index, for_review);
        onUpdateIsSimilarityMatch(
          parentKey + ".review_required." + index,
          for_review_required,
        );
      }
      // if (isReviewRequired && !item.is_deleted) {
      //   onUpdateIsSimilarityMatch(
      //     parentKey + ".reviewed." + index,
      //     isAllChecked ? "false" : "true",
      //   );
      //   onUpdateIsSimilarityMatch(
      //     parentKey + ".review_required." + index,
      //     isAllChecked ? "true" : "false",
      //   );
      // }
    });
  };

  return (
    <>
      <div className="relative">
        <div
          className={cn(
            "text-[14px]   pr-2 min-w-[10px] w-full  bg-gray-100 font-semibold relative text-left py-[5px] h-[46px] ",
            "pt-[5px]",
          )}
        >
          <div className="flex   flex-col pl-[16px]">
            Review All
            <span className="text-[10px] flex  items-center text-gray-400 gap-2 uppercase">
              <Checkbox
                className=""
                disabled={isReadOnly}
                checked={isAllChecked}
                onCheckedChange={() => {
                  handleCheckedAll();
                }}
              />
              Apply to all
            </span>
          </div>
          {/* {has_reviewed?.length !== 0 ? (
            <>
              <Checkbox
                className="ml-2"
                checked={has_reviewed?.length === has_current_reviewed?.length}
                onCheckedChange={() => {
                  handleCheckedAll();
                }}
              />
              Apply TO all
            </>
          ) : null} */}
        </div>
        {data?.map((item: any, index: number) => {
          if (item?.is_deleted) {
            return null;
          }

          // const currentReviewed = temp_reviewed.find(
          //   (crItem: any) => crItem?.row_number === item?.row_number,
          // );

          // const isReviewRequired = review_required_row_no.includes(
          //   currentReviewed?.row_number,
          // );

          return (
            <div
              className={cn(
                "w-full text-center relative h-[40px] ",
                review_required_row_no?.includes(item?.row_number)
                  ? // isReviewRequired && currentReviewed.text === "false"
                    "bg-[#fef2f2] pt-[5px]"
                  : "odd:bg-gray-50 bg-white pt-[3px]",
              )}
              key={index}
            >
              <div className="text-[14px] p-[6px] flex  items-center gap-2 ">
                {/* {currentReviewed.text === "true" ? (
                  <span className="text-green-500 bg-green-50 font-bold text-[13px] border-green-100 border rounded-[50px] px-2">
                    Reviewed
                  </span>
                ) : (
                  <>
                    {isReviewRequired ? (
                      <span className="pl-[10px]">
                        <Checkbox
                          checked={item.text == "true"}
                          onCheckedChange={(prop) => {
                            onUpdateIsSimilarityMatch(
                              parentKey + ".reviewed." + [index] + "",
                              "" + prop,
                            );
                          }}
                        />
                      </span>
                    ) : null}
                  </>
                )} */}

                <span className="pl-[10px]">
                  <Checkbox
                    disabled={isReadOnly}
                    checked={item.text == "true"}
                    onCheckedChange={(prop) => {
                      onUpdateIsSimilarityMatch(
                        parentKey + ".reviewed." + [index] + "",
                        "" + prop,
                      );
                      onUpdateIsSimilarityMatch(
                        parentKey + ".review_required." + [index] + "",
                        "" + !prop,
                      );
                    }}
                  />
                </span>

                {/* {isReviewRequired ? (
                  <span className="pl-[10px]">
                    <Checkbox
                      checked={item.text == "true"}
                      onCheckedChange={(prop) => {
                        onUpdateIsSimilarityMatch(
                          parentKey + ".reviewed." + [index] + "",
                          "" + prop,
                        );
                        onUpdateIsSimilarityMatch(
                          parentKey + ".review_required." + [index] + "",
                          "" + !prop,
                        );
                      }}
                    />
                  </span>
                ) : null} */}

                {
                  // <Checkbox
                  //   checked={item.text === "true"}
                  //   onCheckedChange={(prop) => {
                  //     onUpdateIsSimilarityMatch(
                  //       parentKey + ".reviewed." + [index] + "",
                  //       "" + prop,
                  //     );
                  //   }}
                  // />
                }
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
  return (
    <span
      className="inline-block"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      style={{
        translate: "4px 1px",
      }}
    >
      <span onClick={() => !isReadOnly && onUpdateIsSimilarityMatch(parentKey)}>
        <Checkbox
          id="terms-checkbox"
          name="terms-checkbox"
          disabled={isReadOnly}
        />
      </span>
    </span>
  );
};
